import React, { useEffect, useState } from "react";
import trackingNumberService from "../api/trackingNumberService";

const TrackingNumberPage = () => {
    const [trackingNumbers, setTrackingNumbers] = useState([]);
    const [formData, setFormData] = useState({ number: "" });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchTrackingNumbers();
    }, []);

    const fetchTrackingNumbers = async () => {
        setLoading(true);
        try {
            const data = await trackingNumberService.getTrackingNumbers();
            setTrackingNumbers(data);
        } catch {
            setError("Failed to load tracking numbers.");
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) =>
        setFormData({ ...formData, [e.target.name]: e.target.value });

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await trackingNumberService.createTrackingNumber(formData);
            setFormData({ number: "" });
            fetchTrackingNumbers();
        } catch {
            setError("Failed to create tracking number.");
        }
    };

    return (
        <div className="max-w-2xl mx-auto p-6 bg-white rounded-lg shadow">
            <h2 className="text-2xl font-bold mb-4">Tracking Numbers</h2>
            <form onSubmit={handleSubmit} className="mb-6 flex">
                <input
                    className="border rounded-l px-4 py-2 w-full"
                    name="number"
                    value={formData.number}
                    onChange={handleChange}
                    placeholder="Tracking Number"
                    required
                />
                <button
                    className="bg-blue-600 text-white px-6 rounded-r"
                    type="submit"
                >
                    Add
                </button>
            </form>
            {loading ? (
                <p>Loading...</p>
            ) : error ? (
                <p className="text-red-500">{error}</p>
            ) : (
                <ul>
                    {trackingNumbers.map((tn) => (
                        <li key={tn.id} className="border-b py-2">
                            {tn.number}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default TrackingNumberPage;
